var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-sidebar',{attrs:{"active":_vm.$store.state.sidebars.showCardsCreateForm}},[(_vm.$store.state.views.card_categories.length && _vm.$store.state.sidebars.showCardsCreateForm)?_c('cards-create-form'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }